import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';

class AppHeader2 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            AppHeaderClass: props.AppHeaderClass,
            AppHeaderLeft: props.AppHeaderLeft,
            AppHeaderLeftLink: props.AppHeaderLeftLink,
            AppHeaderTitle: props.AppHeaderTitle,
            AppHeaderRight: props.AppHeaderRight,
            AppHeaderRightLink: props.AppHeaderRightLink,
            AppHeaderSearch: props.AppHeaderSearch || '',
            redirect: false,
			search_text: '',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSearchClick = (e) => {

        e.preventDefault();
        var a = $("#search").hasClass("show");
        if (a) {
            $("#search").removeClass("show");
        }
        else {
            $("#search").addClass("show");
            $("#search .form-control").focus();
        }        
    };

	handleSubmit(event) {
		event.preventDefault();
		this.setState({ redirect: true });
		this.setState({ search_text: event.target.elements.search.value });

		event.target.elements.search.value = '';
	}

    render() { 
	 
       if (this.state.redirect)
       {
           this.setState({ redirect: false });
           return <Redirect to={`/search/${this.state.search_text}`} />;
       }

       return (
            <div>
                <div id="search" className="appHeader">
                    <form className="search-form" onSubmit={this.handleSubmit}>
                        <div className="form-group searchbox">
                            <input type="search" className="form-control" id="search_text" name="search" placeholder="Search..." onKeyDown={this.onKeyDown} minLength="3" />
                            <i className="input-icon">
                                <ion-icon name="search-outline"></ion-icon>
                            </i>
                            <Link to="#" className="ml-1 close toggle-searchbox" onClick={this.handleSearchClick}>
                                <ion-icon name="close-circle"></ion-icon>
                            </Link>
                        </div>
                    </form>
                </div>
                <div className={this.state.AppHeaderClass}>
                    <div className="left">
                        {this.state.AppHeaderLeft=='showLINK' && <Link to={this.state.AppHeaderLeftLink} className="headerButton goBack pl-0"><ion-icon name="chevron-back-outline"></ion-icon></Link> }
                        <Link to="/home" className="headerButton p-0">
                            <img src="/assets/img/done-logo.png" alt="image" className="form-image" />
                        </Link>
                    </div>
                    <div className="pageTitle title-cut">
                        {this.state.AppHeaderSearch!='' &&
                            <div className="chip chip-outline search-chip">
                                <span className="chip-label"> {this.state.AppHeaderSearch} </span>
                                <Link to="/categories" className="chip-delete">
                                    <ion-icon name="close-circle" role="img" className="md hydrated" aria-label="close circle"></ion-icon>
                                </Link>
                            </div>
                        }
                        {this.state.AppHeaderSearch=='' && <div className="title-cut-sub">{this.state.AppHeaderTitle}</div>}
                    </div>        
                    <div className="right">
                        { this.state.AppHeaderRightLink=='SEARCH' && <Link to="#" onClick={(e) => {this.handleSearchClick(e); }} className="headerButton toggle-searchbox"> <ion-icon name="search-outline"></ion-icon> </Link>}
                        { this.state.AppHeaderRightLink!='SEARCH' && this.state.AppHeaderRightLink!='' && <Link to={this.state.AppHeaderRightLink} className="headerButton text-secondary"> {this.state.AppHeaderRight} </Link>}
                        {/* this.state.AppHeaderRightLink=='' && this.state.AppHeaderRight */}
                        <Link to="#" className="headerButton text-light" data-toggle="modal" data-target="#sidebarPanel">
                            <ion-icon name="menu-outline"></ion-icon>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
      
export default AppHeader2;


// WEBPACK FOOTER //
// ./src/components/AppHeader2.js